import type {IdentityVerificationSchema} from '../identityVerification';

export const getOCRPassed = (state: IdentityVerificationSchema) =>
  state.ocrResultData.ocrPassed;
